import { __assign, __rest } from "tslib";
import React from 'react';
import uniqueId from '../utilities/uniqueId';
var STAR_ACTIVE_COLOR = '#FFD362';
var STAR_INACTIVE_COLOR = '#DEE0E8';
var RatingStar = function (_a) {
    var fillPercent = _a.fillPercent, props = __rest(_a, ["fillPercent"]);
    var gradientId = uniqueId('star-gradient__');
    return (React.createElement("svg", __assign({ fill: 'none', height: '15', viewBox: '0 0 16 15', width: '16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: gradientId },
                React.createElement("stop", { offset: "".concat(fillPercent, "%"), stopColor: STAR_ACTIVE_COLOR }),
                React.createElement("stop", { offset: 0, stopColor: STAR_INACTIVE_COLOR }))),
        React.createElement("path", { clipRule: 'evenodd', d: 'M8 12.6317L3.29772 14.4721L3.595 9.43127L0.391548 5.52786L5.27756 4.25288L8 0L10.7224 4.25288L15.6085 5.52786L12.405 9.43127L12.7023 14.4721L8 12.6317Z', fill: "url(#".concat(gradientId, ")"), fillRule: 'evenodd' })));
};
export default RatingStar;
//# sourceMappingURL=RatingStar.js.map